import type { RetryOptions } from '../../types';

export const resolveRetryDelay = ({
  retryDelay,
  maxRetries,
  numberOfFailedAttempts,
  response,
}: {
  retryDelay: RetryOptions['retryDelay'];
  maxRetries: RetryOptions['maxRetries'];
  numberOfFailedAttempts: number;
  response: Response;
}): number => {
  if (typeof retryDelay === 'function') {
    return retryDelay({ maxRetries, numberOfFailedAttempts, response });
  }

  return retryDelay;
};
